import React from 'react'
import PropTypes from 'prop-types'

const exportIconImage = '/assets/exportIcon.png'
const ExportIcon = ({ style, className, width = 20, height = 20 }) => (
  <img src={exportIconImage} alt="Export Icon" width={width} height={height} style={style} />
)

ExportIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default ExportIcon
